// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                           from 'firebase/functions';

// ===== Interfaces =====

import {
    IReattachDetachedAnnotationRequest,
}                           from '../interfaces';

/**
 * Dedicated detached-annotation repair keeps production quote updates scoped
 * to the author/admin repair lane instead of reusing the broader update API.
 */
const reattachDetachedAnnotation = async ({
    test,
    annotationId,
    quote,
    chapterId,
    sectionId,
}: IReattachDetachedAnnotationRequest): Promise<boolean> => {
    const functions = getFunctions();
    const callable = httpsCallable<IReattachDetachedAnnotationRequest, boolean>(
        functions,
        'reattachDetachedAnnotation',
    );
    const payload: IReattachDetachedAnnotationRequest = {
        test,
        annotationId,
        quote,
        chapterId,
        sectionId,
    };
    return callable(payload).then((result) => result.data as boolean).catch((err) => {
        throw err;
    });
};

export default reattachDetachedAnnotation;
